module.exports = __webpack_public_path__ + "img/support.32dae7ed.svg";